import React, { useState, useEffect, useRef } from "react";
import axiosInstance from "../../utils/axios";
import EntityManagement from "../formTemplates/EntityManagement";
import EntityTable from "../templateComponents/EntityTable";

const InstanceConfigurationTable = () => {
  const [formData, setFormData] = useState({
    bec_floor_id: "",
    bec_type_id: "",
    bex_pt_map_X: "",
    bex_pt_map_Y: "",
    bec_instance_key: "",
    bec_id: "",
  });

  const [instances, setInstances] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [editingEntityId, setEditingEntityId] = useState(null);
  const [isTableModalOpen, setIsTableModalOpen] = useState(false);

  const firstFormFieldRef = useRef(null);

  const endpoints = {
    viewAll: "/view_beacon_instance/v1.1",
    register: "/registration_beacon_instance/v1.1",
    update: "/update_beacon_instance/v1.1",
  };

  const loadInstances = async () => {
    try {
      const response = await axiosInstance.post(endpoints.viewAll, {
        view_type: "view all",
      });

      if (response.data.Status === "Success") {
        setInstances(response.data.Data || []);
      } else {
        console.error("API error:", response.data.Message);
      }
    } catch (error) {
      console.error("Error fetching instances:", error);
    }
  };

  useEffect(() => {
    loadInstances();
  }, []);

  const handleFormSubmit = async (e) => {
    e.preventDefault();

   
    const { bec_floor_id, bec_type_id, bex_pt_map_X, bex_pt_map_Y, bec_id } = formData;

    if (!bec_floor_id || !bec_type_id || !bex_pt_map_X || !bex_pt_map_Y || !bec_id) {
      alert("Please fill all required fields.");
      return;
    }

    //  Generate bec_instance_key safely
    const instanceKey = `${bec_floor_id.toString().padStart(2, '0')}${bec_type_id.toString().padStart(2, '0')}${bex_pt_map_X.toString().padStart(4, '0')}${bex_pt_map_Y.toString().padStart(4, '0')}`;

    const payload = {
      bec_floor_id: parseInt(bec_floor_id, 10),
      bec_typ_id: parseInt(bec_type_id, 10), 
      bex_pt_map_X: parseInt(bex_pt_map_X, 10),
      bex_pt_map_Y: parseInt(bex_pt_map_Y, 10),
      bec_instance_key: instanceKey,
      bec_id: parseInt(bec_id, 10),
    };

    if (editMode) {
      payload.bec_inst_id = editingEntityId; 
      try {
        console.log("Update Payload:", payload);
        const response = await axiosInstance.post(endpoints.update, payload);
        if (response.data.Status === "Success") {
          loadInstances();
          resetForm();
        } else {
          console.error("Update failed:", response.data.Message);
        }
      } catch (error) {
        console.error("Update error:", error);
      }
    } else {
      try {
        console.log("Register Payload:", payload);
        const response = await axiosInstance.post(endpoints.register, payload);
        if (response.data.Status === "Success") {
          loadInstances();
          resetForm();
        } else {
          console.error("Registration failed:", response.data.Message);
        }
      } catch (error) {
        console.error("Registration error:", error);
      }
    }
  };

  const resetForm = () => {
    setFormData({
      bec_floor_id: "",
      bec_type_id: "",
      bex_pt_map_X: "",
      bex_pt_map_Y: "",
      bec_instance_key: "",
      bec_id: "",
    });
    setEditMode(false);
    setEditingEntityId(null);
  };

  const handleEdit = (entityId) => {
    const entity = instances.find((ins) => ins.bec_inst_id === entityId);
    if (entity) {
      setFormData({
        bec_floor_id: entity.bec_floor_id.toString(),
        bec_type_id: entity.bec_typ_id.toString(),
        bex_pt_map_X: entity.bex_pt_map_X.toString(),
        bex_pt_map_Y: entity.bex_pt_map_Y.toString(),
        bec_instance_key: entity.bec_instance_key,
        bec_id: entity.bec_id.toString(),
      });
      setEditMode(true);
      setEditingEntityId(entityId);
      if (firstFormFieldRef.current) firstFormFieldRef.current.focus();
      setIsTableModalOpen(false);
    }
  };

  const handleViewTableClick = () => {
    setIsTableModalOpen(true);
  };

  const formFields = [
    { name: "bec_floor_id", label: "Floor ID", type: "text", required: true },
    { name: "bec_type_id", label: "Type ID", type: "text", required: true },
    { name: "bex_pt_map_X", label: "Map X Coord", type: "text", required: true },
    { name: "bex_pt_map_Y", label: "Map Y Coord", type: "text", required: true },
    {
      name: "bec_instance_key",
      label: "Instance Key",
      type: "text",
      required: false,
      disabled: true,
    },
    { name: "bec_id", label: "Beacon ID", type: "text", required: true },
  ];

  const columns = [
    { name: "bec_inst_id", label: "Instance ID" },
    { name: "bec_floor_id", label: "Floor ID" },
    { name: "bec_typ_id", label: "Type ID" },
    { name: "bex_pt_map_X", label: "Map X" },
    { name: "bex_pt_map_Y", label: "Map Y" },
    { name: "bec_instance_key", label: "Instance Key" },
    { name: "bec_id", label: "Beacon ID" },
 
  ];

  return (
    <div className="instance">
      <EntityManagement
        entityName="Beacon Instance"
        formFields={formFields}
        formData={formData}
        setFormData={setFormData}
        handleFormSubmit={handleFormSubmit}
        firstFormFieldRef={firstFormFieldRef}
        handleViewTableClick={handleViewTableClick}
        onEdit={handleEdit}
      />

      {isTableModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <button onClick={() => setIsTableModalOpen(false)}>Close</button>
            <EntityTable
              data={instances}
              columns={columns}
              onEdit={handleEdit}
              keyField="bec_inst_id"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default InstanceConfigurationTable;
